<template>
  <div class="row">
    <div v-for="(customField, index) in customFields" :key="index"
      :class="{ 'col-md-12': fullWidth, 'col-md-4': !fullWidth }">
      <TextInput v-if="customField.type === CUSTOM_FIELD_TYPES.STRING" v-model="iValue[customField.id]" :name="customField.name"
        :label="customField.name" :margin-bottom="marginBottom" @change="() => $emit('change')" />
      <DateInput v-else-if="customField.type === CUSTOM_FIELD_TYPES.DATE" v-model="iValue[customField.id]" :label="customField.name" />
      <NumberInput v-else-if="customField.type === CUSTOM_FIELD_TYPES.NUMBER" v-model="iValue[customField.id]" :label="customField.name" />
    </div>
  </div>
</template>
    
<script>
import { CUSTOM_FIELD_TYPES } from '@src/constants'

export default {
  props: {
    value: {
      type: [Object, null],
      required: true,
    },
    marginBottom: {
      type: Number,
      default: undefined,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      CUSTOM_FIELD_TYPES,
    }
  },

  computed: {
    iValue: {
      get() { return this.value },
      set(v) {
        this.$emit('input', v)
      },
    },
    customFields() {
      return this.$store.getters["auth/customFields"];
    },
  },

  mounted() {
  },

  methods: {
  }
}
</script>
    